import store from '../store'
import {AccessControlApi} from '../request/AccessControl/api'

async function system () {
  if (!store.state.doorControl.SystemPermission.isCheck) {
    await AccessControlApi.getFunctionList('101')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setSystemPermission', checkPermission(store.state.doorControl.SystemPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.SystemPermission)
        }
      })
  }
}

async function institution () {
  if (!store.state.doorControl.InstitutionPermission.isCheck) {
    await AccessControlApi.getFunctionList('201')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setInstitutionPermission', checkPermission(store.state.doorControl.InstitutionPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.InstitutionPermission)
        }
      })
  }
}

async function user () {
  if (!store.state.doorControl.UserPermission.isCheck) {
    await AccessControlApi.getFunctionList('301')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setUserPermission', checkPermission(store.state.doorControl.UserPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.UserPermission)
        }
      })
  }
}

async function role () {
  if (!store.state.doorControl.RolePermission.isCheck) {
    await AccessControlApi.getFunctionList('302')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setRolePermission', checkPermission(store.state.doorControl.RolePermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.RolePermission)
        }
      })
  }
}

async function log () {
  if (!store.state.doorControl.LogPermission.isCheck) {
    await AccessControlApi.getFunctionList('303')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setLogPermission', checkPermission(store.state.doorControl.LogPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.LogPermission)
        }
      })
  }
}

async function department () {
  if (!store.state.doorControl.departmentPermission.isCheck) {
    await AccessControlApi.getFunctionList('501')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setDepartmentPermission', checkPermission(store.state.doorControl.departmentPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.departmentPermission)
        }
      })
  }
}

async function person () {
  if (!store.state.doorControl.personPermission.isCheck) {
    await AccessControlApi.getFunctionList('502')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setPersonPermission', checkPermission(store.state.doorControl.personPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.personPermission)
        }
      })
  }
}

async function deviceArea () {
  if (!store.state.doorControl.deviceAreaPermission.isCheck) {
    await AccessControlApi.getFunctionList('401')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setDeviceAreaPermission', checkPermission(store.state.doorControl.deviceAreaPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.deviceAreaPermission)
        }
      })
  }
}

async function device () {
  if (!store.state.doorControl.devicePermission.isCheck) {
    await AccessControlApi.getFunctionList('401') // 权限未合并前只查设备402
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setDevicePermission', checkPermission(store.state.doorControl.devicePermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.devicePermission)
        }
      })
  }
}

async function door () {
  if (!store.state.doorControl.doorPermission.isCheck) {
    await AccessControlApi.getFunctionList('403')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setDoorPermission', checkPermission(store.state.doorControl.doorPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.doorPermission)
        }
      })
  }
}

async function passRule () {
  if (!store.state.doorControl.PassRulePermission.isCheck) {
    await AccessControlApi.getFunctionList('601')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setPassRulePermission', checkPermission(store.state.doorControl.PassRulePermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.PassRulePermission)
        }
      })
  }
}

async function commPassSetting () {
  if (!store.state.doorControl.CommPassSettingPermission.isCheck) {
    await AccessControlApi.getFunctionList('602')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setCommPassSettingPermission', checkPermission(store.state.doorControl.CommPassSettingPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.CommPassSettingPermission)
        }
      })
  }
}

async function holiday () {
  if (!store.state.doorControl.holidayPermission.isCheck) {
    await AccessControlApi.getFunctionList('404')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setHolidayPermission', checkPermission(store.state.doorControl.holidayPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.holidayPermission)
        }
      })
  }
}

async function tempPassSetting () {
  if (!store.state.doorControl.TempPassSettingPermission.isCheck) {
    await AccessControlApi.getFunctionList('603')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setTempPassSettingPermission', checkPermission(store.state.doorControl.TempPassSettingPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.TempPassSettingPermission)
        }
      })
  }
}

async function passHistory () {
  if (!store.state.doorControl.PassHistoryPermission.isCheck) {
    await AccessControlApi.getFunctionList('604')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setPassHistoryPermission', checkPermission(store.state.doorControl.PassHistoryPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.PassHistoryPermission)
        }
      })
  }
}

async function realTimePass () {
  if (!store.state.doorControl.RealTimePassPermission.isCheck) {
    await AccessControlApi.getFunctionList('605')
      .then(res => {
        if (res.retCode === '0000') {
          // console.log(res.BizBodyMsg.functionList)
          store.commit('doorControl/setRealTimePassPermission', checkPermission(store.state.doorControl.RealTimePassPermission, res.BizBodyMsg.functionList))
          // console.log(store.state.doorControl.RealTimePassPermission)
        }
      })
  }
}

function checkPermission (permissionDict, permissionList) {
  let tempDict = JSON.parse(JSON.stringify(permissionDict))
  let objList = Object.keys(permissionDict)
  for (let item of permissionList) {
    for (let obj of objList) {
      if (item.functionId === tempDict[obj].functionId) {
        tempDict[obj].show = true
        break
      }
    }
  }
  return tempDict
}

let rights = {system, institution, department, deviceArea, person, door, device, user, role, log, holiday, passRule, commPassSetting, tempPassSetting, passHistory, realTimePass}

export {checkPermission, rights}



// WEBPACK FOOTER //
// ./src/util/handlePermission.js